import httpClient from '../../shared/services/httpClient';

export const SearchRegion = async (cityId: number) => {
  return await httpClient.get(`/region/city/${cityId}`, { skipAuth: true });
};
